import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ErrorsComponent } from './errors.component';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';


@NgModule({
  declarations: [ErrorsComponent],
  imports: [
    CommonModule,
    FGBSharedModule
  ],
  exports: [ErrorsComponent],
})
export class ErrorsModule {}
